import React from 'react';
import { useTranslation } from 'react-i18next';
import { Nav } from 'shards-react';
import SidebarNavItem from './SidebarNavItem';
import useNavConfig from '../../../hooks/useNavConfig';

const SidebarNavItems = (): React.ReactElement => {
  const { t } = useTranslation();
  const navItems = useNavConfig(t);
  // console.log(navItems);

  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  // }, []);

  // EVENT HANDLER
  // ================================================================================

  // VIEW
  // ================================================================================

  return (
    <div className="nav-wrapper">
      {navItems.map((nav, idx) => (
        <div key={idx}>
          <h6 className="main-sidebar__nav-title">{nav.title}</h6>
          {typeof nav.items !== 'undefined' && nav.items.length && (
            <Nav className="nav--no-borders flex-column">
              {nav.items.map((item, idx) => (
                <SidebarNavItem key={'nav' + idx} item={item} />
              ))}
            </Nav>
          )}
        </div>
      ))}
    </div>
  );
};

export default SidebarNavItems;
